import { createClient, type SupabaseClient } from '@supabase/supabase-js';

// ============================================================================
// Supabase client singleton
// ----------------------------------------------------------------------------
// Reads URL and anon key from Vite env vars at build time. In Netlify these
// come from VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY. For local dev,
// set them in .env.local at the repo root (gitignored).
// ============================================================================

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    // Don't throw in production — render an error UI instead. But log loudly.
    // eslint-disable-next-line no-console
    console.error(
        '[PT-OR] Missing Supabase env vars. ' +
        'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY must be set at build time.'
    );
}

export const supabase: SupabaseClient = createClient(
    SUPABASE_URL,
    SUPABASE_ANON_KEY,
    {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: false  // we handle ?token= ourselves
        }
    }
);
